import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchWorkScheduleServicesWithTree } from './workScheduleApi';

export const useWorkScheduleServicesWithTreeQuery = (
  { workScheduleServiceNameId },
  options
) =>
  useQuery(
    workScheduleQueryKeys.servicesWithTree(workScheduleServiceNameId),
    () => fetchWorkScheduleServicesWithTree({ workScheduleServiceNameId }),
    {
      enabled: Boolean(workScheduleServiceNameId),
      staleTime: 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
      ...options,
    }
  );
